import SplitType from 'split-type';
import gsap from 'gsap';
import {useEffect} from "react";
import {Routes, Route, useLocation} from "react-router-dom";
import {AnimatePresence} from "framer-motion";

import './Styles/App.css';
import NavBar from "./Components/NavBar";
import ScrollHint from "./Components/ScrollHint";
import Home  from "./Components/Home";
import About from "./Components/About";
import Contact from "./Components/Contact";
import NotFound from "./Components/NotFound";

function App() {

  const location = useLocation();

  useEffect(() => {
    const titles = {"/": "Joyastick", "/projects": "Projects | Joyastick", "/contact": "Contact | Joyastick"};
    document.title = titles[location.pathname] || "Page not found | Joyastick";
  }, [location.pathname]);

  return (
    <>
      <NavBar/>
      <ScrollHint/>
      <AnimatePresence mode = "wait">
        <Routes location = {location} key = {location.pathname}>
          <Route index element={<Home />}/>
          <Route path="/projects" element={<About />}/>
          <Route path="/contact" element={<Contact />}/>
          <Route path="*" element={<NotFound />}/>
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
